<div>
    <div *ngIf="config?.title" fxLayout="row" fxLayoutAlign="center center" class="info-title-wrapper">
        <span class="info-title-text">{{ config?.title }}</span>
    </div>
  <new-connection (connectionChange)="connectionChange($event)" [inputConfig]="config"></new-connection>
</div>
